
export const userLogin = (user: any, token: string, position: string) => {
  return {
    type: "@user/login",
    payload: { user: user, token: token, position: position },
  };
};

// Actualiza los datos del usuario (p. ej. permisos refrescados con /employee/me)
export const userUpdate = (user: any) => {
  return {
    type: "@user/update",
    payload: { user: user },
  };
};

export const userLogout = () => {
  return {
    type: "@user/logout",
  };
};
